var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('b-jumbotron',{staticClass:"vertical-center"},[_c('b-col',{attrs:{"align":"center"}},[_c('b-card',[(!_vm.loggedin)?_c('b-button',{attrs:{"size":"lg"},on:{"click":_vm.login}},[_vm._v("Login")]):_vm._e()],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }